
export enum StatisticState {
  Sent = 0,
  Received = 1,
  SendFailed = 2,
  ReceiveFailed = 3,
}

export enum StatisticsPeriod {
  Hourly = 0,
  Daily,
  Monthly,
  Yearly,
}


export interface StateCounts {
    total: number;
    byDirection: { [key: string]: number };
}

export interface ResponseBusinessDocuments {
    period: Date;
    sender: string;
    receiver: string;
    sentCount: StateCounts;
    sendFailed: StateCounts;
    retrievedCount: StateCounts;
    retrievedFailed: StateCounts;
}
export enum TransferDirection {
    EasxToEasx = 0,
    EasxToBvg = 1,
    BvgToBvg = 2,
    BvgToEasx = 3,
}

export const DirectionLabels: Record<string, string> = {
    0: 'EASX → EASX',
    1: 'EASX → BVG',
    2: 'BVG → BVG',
    3: 'BVG → EASX',
};